export default __webpack_public_path__ + "static/examp1-2355783b28fa0c716adf599546ed4ff8.gif";